import React from 'react'
import styled, { css } from 'styled-components'

const width = '85'
const height = '85'
const viewBox = '0 0 85 85'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g fill="none" fillRule="evenodd" transform="translate(2 2)" key="key-0">
      <path
        fill="#FFF"
        d="M40.84 65c-2.78 0-5.44-.621-7.903-1.845-4.475-2.223-7.841-6.301-9.236-11.19-1.396-4.887-.687-10.12 1.945-14.356 3.003-4.833 6.188-9.657 9.268-14.322C36.447 20.965 41 14 41 14s4.55 7.047 6.002 9.265c3.07 4.683 6.243 9.526 9.295 14.33 3.282 5.26 3.596 11.956.828 17.485C54.107 61.106 47.715 65 40.84 65zM41 25.027l-1.01 1.546c-2.446 3.745-4.975 7.618-7.343 11.47a9.625 9.625 0 0 0-1.17 2.857 3.693 3.693 0 0 0-.156.838c-.006.091-.013.182-.013.274a3.682 3.682 0 0 0 3.674 3.69 3.682 3.682 0 0 0 3.674-3.688v-.002-.007c-.01-.425 1.305-10.417 2.344-16.978z"
      />
      <circle
        cx="40.5"
        cy="40.5"
        r="40.5"
        stroke="#FFF"
        strokeWidth="3"
        opacity=".3"
      />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconEngineDiesel'
})
